<!-- 新增商品第三步 -->
<template>
  <div>
    <div class="container">
      <div class="title">
        <span>商品基本信息</span>
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="商品组:按商品属性自动划分商品组合"
          placement="right"
        >
          <el-button type="text"><i class="el-icon-question"></i></el-button>
        </el-tooltip> -->
      </div>
      <div class="info-content">
        <div class="info-form">
          <el-row>
            <el-col :span="12">
              <span class="item-name">所属分类：</span>
              <span class="item-info">{{ category }}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 14px">
            <el-col :span="12">
              <span class="item-name">商品品牌：</span>
              <span class="item-info">{{ productInfo.brandName }}</span>
            </el-col>
            <el-col :span="12">
              <span class="item-name">税率：</span>
              <span class="item-info">{{ productInfo.taxRateValue }}%</span>
            </el-col>
          </el-row>
          <!-- <el-row>
             <el-col :span="12">
                 <span class="item-name">商品组名称：{{productInfo.teamName}}</span>
             </el-col>
             <el-col :span="12">
                 <span class="item-name">商品组编号：{{productInfo.teamNo}}</span>
             </el-col>
         </el-row> -->
        </div>
        <div class="info-table">
          <!-- 	:header-cell-style="getRowClass"
					:row-class-name="tableRowClassName" -->
          <el-table
            :data="tableData"
            border
            :header-cell-style="{
              color: '#333333',
              fontSize: '14px',
              backgroundColor: '#f5f5f5',
            }"
            style="width: 100%"
          >
            <el-table-column prop="attributeName" label="属性" width="180">
              <!-- eslint-disable-next-line -->
              <template slot="header" slot-scope="scope">
                <span class="head-title"
                  ><i style="color: #fa0c18; margin-right: 5px">*</i>属性</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="attributeValueList" label="属性值">
              <!-- eslint-disable-next-line -->
              <template slot="header" slot-scope="scope">
                <span class="head-title"
                  ><i style="color: #fa0c18; margin-right: 5px">*</i
                  >属性值</span
                >
              </template>
              <!-- eslint-disable-next-line -->
              <template slot-scope="scope">
                <div
                  v-for="item in scope.row.attributeValueList"
                  :key="item.attributeValueId"
                >
                  <span v-if="item.checked == true">{{
                    item.attributeValue
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="unitList" label="计量单位">
              <!-- eslint-disable-next-line -->
              <template slot="header" slot-scope="scope">
                <span class="head-title"
                  ><i style="color: #fa0c18; margin-right: 5px">*</i
                  >计量单位</span
                >
              </template>
              <!-- eslint-disable-next-line -->
              <template slot-scope="scope">
                <div v-for="item in scope.row.unitList" :key="item.unitId">
                  <span v-if="item.checked == true">{{ item.unitName }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 商品列表 -->
    <product-list></product-list>
    <!-- <div class="btn-box">
      <el-button>上一步</el-button>
      <el-button type="primary" @click="goToUrl('/createProductsSec')"
        >下一步</el-button
      >
      <el-button type="primary" @click="goToUrl('/createProductsSec')"
        >提交审核</el-button
      >
    </div> -->
  </div>
</template>

<script>
import productList from '../../../components/product/productManage/productList.vue';

export default {
  components: {
    productList,
  },
  data() {
    return {
      active: 2,
      input1: '',
      fristCategry: ['动力轴', '动力轴', '动力轴', '动力轴', '动力轴'],
      productInfo: {},
      tableData: [],
      category: '',
    };
  },
  computed: {},
  activated() {
    const newCategory = this.$getStore('categoryName');
    if (newCategory != this.category) {
      this.category = newCategory;
      this.productInfo = this.$store.state.productList;
      this.tableData = this.$store.state.categoryList;
    }
  },

  created() {
    this.productInfo = this.$store.state.productList;
    this.tableData = this.$store.state.categoryList;
    this.category = this.$getStore('categoryName');
    console.log(this.tableData);
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.container {
  .title {
    // border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
      color: #000;
    }
  }
}
.sort-content {
  padding: 0 30px;
  .sort-search {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
.btn-box {
  display: flex;
  margin-top: 30px;
  justify-content: center;
}
.info-form {
  padding: 17px 0;
  .item-name {
    margin-bottom: 30px;
    color: #999;
    font-size: 14px;
  }
  .item-info {
    color: #000;
    font-size: 14px;
  }
}
.info-table {
  .head-title {
    color: #333;
    font-size: 14px;
  }
}
</style>
